<template>
    <div class="kt-portlet">
        <div class="kt-portlet__body">
            <div id="user_transaction_chart" style="height: 200px;"></div>
        </div>
        <kt-button
                class="m-2 ml-auto"
                size="md"
                variant="success"
                type="button"
                id="user_export_btn"
                @click="exportToExcel"
        >
            {{ $t('btn.export_transaction_to_excel') }}
        </kt-button>
    </div>
</template>

<script>
import jQuery from 'jquery'
import $ from 'jquery'
import { ApiUrl } from '@/common/api.service'
import 'jquery-flot'
import { i18n } from '@/plugins/i18n'
import axios from 'axios';
import ApexCharts from "apexcharts";
import {totalOptions, transactionStatusVariant} from "@/constants/ApexChartOptions";

export default {
    name: 'user_monthly_transaction_chart',

    props: {
        chart_data: {
            default() {
                return {}
            }
        },
    },
    methods: {
      exportToExcel(){
        axios({
          url: ApiUrl.path('dashboard/transaction-excel'),
          method: 'GET',
          responseType: 'blob',
        }).then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');

          fileLink.href = fileURL;
          fileLink.setAttribute('download', 'transactions.xlsx');
          document.body.appendChild(fileLink);

          fileLink.click();
        });

      },
      fillOptions(){
        totalOptions.colors = this.fillColors()
        totalOptions.series = this.fillSeries()
        try {
          totalOptions.yaxis.title.text = ''
        } catch (e) {
          totalOptions.yaxis[0].title.text = ''
        }
        totalOptions.xaxis.categories = this.fillDateAxis()
      },
      fillSeries(){
        let data = []
        let chart_data = this.chart_data

        let succeeded = {
          name: 'موفق',
          data: Object.values(chart_data.succeeded),
        }

        let failed = {
          name: 'ناموفق',
          data: Object.values(chart_data.failed),
        }

        data.push(succeeded)
        data.push(failed)

        return data
      },
      fillColors(){
        let data = []
        let series = this.fillSeries()

        Object.values(series).forEach(function (status) {
          data.push(transactionStatusVariant.get(status.name))
        })
        return data
      },
      fillDateAxis() {
        let data = []
        let date_axis = this.chart_data.axis
        Object.keys(date_axis).forEach(function (item) {
          data.push(date_axis[item])
        })
        return data
      }
    },
    mounted() {
      this.fillOptions()
      let chart = new ApexCharts(document.querySelector("#user_transaction_chart") , totalOptions)
      chart.render()
    },
}
</script>

<style>
    #tooltip {
        z-index: 100!important;
    }
    #kt_body > :first-child{
        z-index: initial !important;
    }
    .legend {
        position: absolute;
        bottom: 0;
    }
</style>